<template>
    <div class='page'>
        <div class="content">
           <div class="center audit_wrap"><img class="audit" src="https://o-yzx.bysjy.com.cn/frontend/audit_icon.png" alt=""></div>
           <div class="center title">信息提交成功</div>
           <div class="center status">正在审核中...</div>
           <div class="center know">我知道了</div>
        </div>
    </div>
</template>
<script>
import {Image as VanImage,Button} from 'vant';
import env from '@/utils/env'


export default {
        name: "audit",
        components:{
           [Button.name]:Button,
        },
        data(){
            return {
                checked: false,
            }
        },
        mounted() {
          
        },
        methods:{
          
        }
    }

</script>

<style scoped>

.page {
  background-color: #FFFFFF;
  height: 100vh;
  padding-top: 100px;
}
.content{
  width: 80%;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  margin: 0 auto;
  padding-top: 20px;
  border-radius: 16px;
  overflow: hidden;
}
.title{
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
.status{
  font-size: 14px;
  font-weight: normal;
  line-height: 45px;
  color: #808080;
}
.know{
  background: #3399FF;
  height: 50px;
  line-height: 50px;
  color: #FFF;
}
.know:active{
  background-color: #55a0eb;
}
.center{
  text-align: center;
}

.audit{
  width: 180px;
}

</style>